import React from 'react'
import styled, { keyframes } from 'styled-components'

const DrawCheck = keyframes`
  from {
    stroke-dashoffset: 50;
  }
  to {
    stroke-dashoffset: 0;
  }
`

const SpinnerCircle = styled.path<{
  animationDelay: string
  animationSpeed: string
}>`
  stroke-dasharray: 50;
  stroke-dashoffset: 50;
  fill: none;
  animation: ${DrawCheck} ${({ animationSpeed }) => animationSpeed} ease forwards;
  animation-delay: ${({ animationDelay }) => animationDelay};
`

interface SuccessSpinnerProps extends React.SVGProps<SVGSVGElement> {
  animationDelay?: string
  animationSpeed?: string
}

function SuccessSpinner({
  animationDelay = '0s',
  animationSpeed = '0.5s',
  ...props
}: SuccessSpinnerProps): React.ReactElement {
  return (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg" strokeWidth={4} stroke="white" {...props}>
      <SpinnerCircle
        d="M16 27L23 34L36 20"
        animationDelay={animationDelay}
        animationSpeed={animationSpeed}
      />
    </svg>
  )
}

export default SuccessSpinner
